<template>
    <ion-page>
        <ion-content :fullscreen="true">
            <div id="container">
                <!-- Premium stylized maritime brand logo -->
                <div class="logo-container">
                    <div class="logo-circle">
                        <svg viewBox="0 0 100 100" class="brand-logo-svg">
                            <!-- Stylized cargo vessel outline -->
                            <path d="M20,60 L80,60 L85,48 L15,48 Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>
                            <path d="M35,48 L35,35 L48,35 L48,48 M55,48 L55,25 L65,25 L65,48" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>
                            <path d="M10,70 Q25,65 40,70 Q55,75 70,70 Q85,65 90,70" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
                            <path d="M15,78 Q30,73 45,78 Q60,83 75,78 Q85,75 90,78" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity="0.6"/>
                            <circle cx="50" cy="50" r="42" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="2 4" opacity="0.4" />
                        </svg>
                    </div>
                    <h1 class="brand-name">Jahaji</h1>
                    <p class="brand-subtitle">Management Console</p>
                </div>

                <!-- Glassmorphic Login Form Card -->
                <div class="login-card">
                    <h2 class="card-title">Welcome Back</h2>
                    <p class="card-subtitle">Sign in to your account to continue</p>
                    
                    <!-- Username Input Wrapper -->
                    <div class="input-wrapper">
                        <ion-icon :icon="personOutline" class="input-icon"></ion-icon>
                        <ion-input v-model="userName" placeholder="Username" class="custom-input"></ion-input>
                    </div>
                    
                    <!-- Password Input Wrapper -->
                    <div class="input-wrapper">
                        <ion-icon :icon="lockClosedOutline" class="input-icon"></ion-icon>
                        <ion-input v-model="password" :type="showPassword ? 'text' : 'password'" placeholder="Password" class="custom-input"></ion-input>
                        <ion-button fill="clear" size="small" class="password-toggle" @click="showPassword = !showPassword">
                            <ion-icon :icon="showPassword ? eyeOffOutline : eyeOutline"></ion-icon>
                        </ion-button>
                    </div>
                    
                    <!-- Remember Me Row -->
                    <div class="remember-row">
                        <ion-checkbox v-model="rememberMe" color="primary" class="custom-checkbox"></ion-checkbox>
                        <ion-label class="remember-label" @click="rememberMe = !rememberMe">Remember Me</ion-label>
                    </div>
                    
                    <!-- Login Button -->
                    <ion-button expand="block" class="login-button" @click="loginAttempt()">
                        Sign In
                    </ion-button>
                </div>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonContent,
    IonPage,
    IonButton,
    menuController,
    IonLabel,
    IonInput,
    IonCheckbox,
    IonIcon,
    alertController,
    loadingController,
    useBackButton,
    useIonRouter
} from '@ionic/vue';
import { defineComponent } from 'vue';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { takePushRoute } from '../pushNotifications';
import {
    personOutline,
    lockClosedOutline,
    eyeOutline,
    eyeOffOutline
} from 'ionicons/icons';

export default defineComponent({
  name: 'Login',
  data(){
      return {
          userName:'',
          password:'',
          rememberMe:true,
          exitCount:0,
          showPassword: false,
          
          // Icons
          personOutline,
          lockClosedOutline,
          eyeOutline,
          eyeOffOutline
      }
  },
  created(){
    this.exitCount = 0;
    const ionRouter = useIonRouter();
    console.log(ionRouter.canGoBack());
    useBackButton(-1, () => {
      this.exitCount++;
      if (this.$route.name == "home" && this.exitCount == 2) {
        App.exitApp();
      }
    });
  },
  mounted(){
      menuController.enable(false);
  },
  methods:{
      async presentLoading() {
      const loading = await loadingController
        .create({
          message: 'Logging in.....',
          duration: 60 * 1000,
        });

      await loading.present();
        return loading;
    },
      async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();
    },
      async loginAttempt(){
          const data={
              'username':this.userName,
              'password':this.password,
          };
          // This phone's push token, so notifications for this user reach it ("test" is the
          // stand-in browser builds store; it is not a phone).
          const fcmToken = window.localStorage.getItem('fcm_token');
          if(fcmToken!=null && fcmToken!=='test'){
              data['fcm_token']=fcmToken;
          }
        const loading=await this.presentLoading();
        this.$http.post('login',data).then(async response=>{
          console.log(response);
            if(response.data.status){
                window.localStorage.setItem('username', this.userName);
                window.localStorage.setItem('password', this.password);
                window.localStorage.setItem('name', response.data.name);
                window.localStorage.setItem('email', response.data.email);
                window.localStorage.setItem('user_type', response.data.user_type);
                window.localStorage.setItem('avatarImg', response.data.avatarImg!= null?response.data.avatarImg:'');
                if(this.rememberMe){
                  window.localStorage.setItem('rememberMe', 1);
                }
                await menuController.enable(true);
                if(Capacitor.isNativePlatform() && !data['fcm_token']){
                    // No token yet (registration failed or was late): ask again. App.vue saves
                    // it on this user as soon as it arrives.
                    PushNotifications.register().catch(() => undefined);
                }
                // A notification tapped while signed out opens its request now.
                this.$router.push(takePushRoute() || '/home');
            }else{
                this.presentAlert(response.data.message);
            }
            loading.dismiss();
        });
      }
  },
  components: {
    IonContent,
    IonPage,
    IonButton,
    IonLabel,
    IonInput,
    IonCheckbox,
    IonIcon
  }
});
</script>

<style scoped>
/* Full screen styling */
ion-content {
  --background: radial-gradient(circle at 10% 20%, rgb(240, 245, 255) 0%, rgb(228, 235, 250) 90%);
}

#container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 24px;
}

/* Brand Logo Section */
.logo-container {
  text-align: center;
  margin-bottom: 30px;
}

.logo-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px auto;
  box-shadow: 0 10px 25px rgba(56, 128, 255, 0.15);
  color: var(--ion-color-primary, #3880ff);
  padding: 12px;
}

.brand-logo-svg {
  width: 100%;
  height: 100%;
}

.brand-name {
  font-size: 32px;
  font-weight: 800;
  color: var(--ion-color-dark, #222428);
  margin: 0;
  letter-spacing: 0.5px;
}

.brand-subtitle {
  font-size: 13px;
  color: var(--ion-color-medium, #92949c);
  margin: 4px 0 0 0;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Login Card Container */
.login-card {
  width: 100%;
  max-width: 400px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-radius: 20px;
  padding: 30px 24px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.6);
  margin-bottom: 20px;
}

.card-title {
  margin: 0 0 6px 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--ion-color-dark);
}

.card-subtitle {
  margin: 0 0 24px 0;
  font-size: 14px;
  color: var(--ion-color-medium);
}

/* Custom Input Wrapper */
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: white;
  border: 1.5px solid rgba(146, 148, 156, 0.2);
  border-radius: 12px;
  margin-bottom: 16px;
  padding: 4px 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.01);
}

.input-wrapper:focus-within {
  border-color: var(--ion-color-primary, #3880ff);
  box-shadow: 0 4px 12px rgba(56, 128, 255, 0.08);
  transform: translateY(-1px);
}

.input-icon {
  font-size: 20px;
  color: var(--ion-color-medium, #92949c);
  margin-right: 10px;
  transition: color 0.3s ease;
}

.input-wrapper:focus-within .input-icon {
  color: var(--ion-color-primary, #3880ff);
}

.custom-input {
  --padding-top: 10px;
  --padding-bottom: 10px;
  --padding-start: 0;
  --padding-end: 0;
  font-size: 15px;
  color: var(--ion-color-dark);
  flex: 1;
}

.password-toggle {
  margin: 0;
  --padding-start: 4px;
  --padding-end: 4px;
  height: 32px;
  color: var(--ion-color-medium);
}

/* Remember me row */
.remember-row {
  display: flex;
  align-items: center;
  margin: 18px 0 24px 0;
  padding-left: 2px;
}

.custom-checkbox {
  --border-radius: 6px;
  --size: 18px;
  margin-right: 10px;
}

.remember-label {
  font-size: 14px;
  color: var(--ion-color-step-700, #444);
  font-weight: 500;
  user-select: none;
}

/* Button with gradient */
.login-button {
  --background: linear-gradient(135deg, var(--ion-color-primary, #3880ff) 0%, var(--ion-color-primary-tint, #4c8dff) 100%);
  --border-radius: 12px;
  --box-shadow: 0 6px 16px rgba(56, 128, 255, 0.25);
  font-weight: 700;
  font-size: 16px;
  margin: 0;
  height: 48px;
  letter-spacing: 0.5px;
}

.login-button:active {
  transform: scale(0.98);
}
</style>